import { Box } from "@mui/material";
import React from "react";
import {
  DrawerContentBoxSxProps,
  StyledNavLink,
  StyledNavLinkDivider,
  StyledNavTypography,
} from "./styles";

interface Props {
  onInteraction: (event: React.KeyboardEvent | React.MouseEvent) => void;
}

export default function DrawerContent({onInteraction}: Props) {
  return (
    <Box
      sx={DrawerContentBoxSxProps}
      role="presentation"
      onKeyDown={onInteraction}
      onClick={onInteraction}
    >
      <StyledNavLinkDivider />
      <StyledNavLink
        className={({ isActive, isPending }) =>
          isActive ? "active" : isPending ? "pending" : ""
        }
        to="/"
      >
        <StyledNavTypography>Home</StyledNavTypography>
      </StyledNavLink>
      <StyledNavLinkDivider />
      <StyledNavLink
        className={({ isActive, isPending }) =>
          isActive ? "active" : isPending ? "pending" : ""
        }
        to="/giving"
      >
        <StyledNavTypography>Giving</StyledNavTypography>
      </StyledNavLink>

      <StyledNavLinkDivider />
      <StyledNavLink
        className={({ isActive, isPending }) =>
          isActive ? "active" : isPending ? "pending" : ""
        }
        to="/calendar"
      >
        <StyledNavTypography>Calendar</StyledNavTypography>
      </StyledNavLink>
      <StyledNavLinkDivider />
      <StyledNavLink
        className={({ isActive, isPending }) =>
          isActive ? "active" : isPending ? "pending" : ""
        }
        to="/ministries"
      >
        <StyledNavTypography>Ministries</StyledNavTypography>
      </StyledNavLink>
      <StyledNavLinkDivider />
      <StyledNavLink
        className={({ isActive, isPending }) =>
          isActive ? "active" : isPending ? "pending" : ""
        }
        to="/resources"
      >
        <StyledNavTypography>Resources</StyledNavTypography>
      </StyledNavLink>
      <StyledNavLinkDivider />
      <StyledNavLink
        className={({ isActive, isPending }) =>
          isActive ? "active" : isPending ? "pending" : ""
        }
        to="/our-priest"
      >
        <StyledNavTypography>Our Priest</StyledNavTypography>
      </StyledNavLink>
      <StyledNavLinkDivider />
      <StyledNavLink
        className={({ isActive, isPending }) =>
          isActive ? "active" : isPending ? "pending" : ""
        }
        to="/contact-us"
      >
        <StyledNavTypography>Contact Us</StyledNavTypography>
      </StyledNavLink>
      <StyledNavLinkDivider />
    </Box>
  );
}
